export const userType = {
  TALENT: "Talent",
  USER: "User",
  BUSINESS: "Business",
};
